import { render, staticRenderFns } from "./albumList.vue?vue&type=template&id=9f672854&scoped=true&"
import script from "./albumList.vue?vue&type=script&lang=js&"
export * from "./albumList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f672854",
  null
  
)

export default component.exports